import { render } from "./Page.vue?vue&type=template&id=085be38f&scoped=true&ts=true"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"

import "./Page.vue?vue&type=style&index=0&id=085be38f&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085be38f"]])

export default __exports__